import {
  CommentContextProvider,
  CommentContextProviderProps,
} from './CommentContextProvider';
import CommentContextContainer from './CommentContextProvider.container';

export default CommentContextContainer(CommentContextProvider);
export { type CommentContextProviderProps };
